import React from 'react'
import { makeStyles } from '@mui/styles'

const RadioContent = (props) => {
  const { title, subtitle } = props
  const classes = useStyles()

  return (
    <div className={classes.container}>
      <span className={classes.title}>{title}</span>
      {subtitle && <span className={classes.subtitle}>{subtitle}</span>}
    </div>
  )
}

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
  },
  title: {
    fontSize: theme.fontSizes.default,
    fontWeight: theme.fontSizes.medium,
    lineHeight: '1.86',
    letterSpacing: '0.14px',
    color: '#215999',
  },
  subtitle: {
    fontSize: theme.fontSizes.tooltip,
    lineHeight: '1.45',
    letterSpacing: '0.11px',
    color: theme.textMuted,
  },
}))

export default RadioContent
